<template>
  <section class="landingPage">
    <div class="landingPageImage">
      <img class="image" :src="hgMainLanding" alt="highgrounds-grass-fields">
      <img class="logo" :src="hgMainLogo" alt="highgrounds-main-logo">
      <div class="landingPageText">
        <div class="landingPageTitle">{{description.title}}</div>
        <div class="landingPageSubTitle">{{description.subTitle}}</div>
        <router-link class="button" to="/">Learn More</router-link>
      </div>
    </div>
    <div class="landingPageDescription">
      <img class="landingPageDescriptionImage" :src="hgMainDescription" alt="highgrounds-brain">
      <div class="landingPageDescriptionText">
        <div class="landingPageDescriptionTitle">{{description.title}}</div>
        <div class="landingPageDescriptionSubTitle">{{description.subTitle}}</div>
        <router-link class="button" to="/About">Learn More</router-link>
      </div>
      <div class="landingPageDescriptionTinter"></div>
    </div>
    <div class="landingPageTinter"></div>
  </section>
</template>

<script>
import HGMainLanding from '@/assets/hgMain/hgMainLanding.jpg';
import HGMainLogo from '@/assets/hgMain/hgMainLogoTitle.svg'
import HGMainDescription from '@/assets/hgMain/brain.svg';

export default {
  name: 'LandingPage',
  data() {
    return {
      hgMainLanding: HGMainLanding,
      hgMainLogo: HGMainLogo,
      hgMainDescription: HGMainDescription,
      description: {
        title: 'AI Innovation with Highground',
        subTitle: 'Highground Technologies is a renowned international Artificial Intelligence research and development company. The Highground development team has worked together for more than 14 years, delivering cutting edge technology solutions to leaders from various sectors, including Fortune 100 companies. Our Highground team has provided solutions that range from mobile applications deployments to carrier grade delivery applications.'
      }
    }
  },
}
</script>

<style scoped>
@media (max-width: 900px) {
  .landingPage {
    position: relative;
    height: auto;
    width: 100%;
    padding-top:75px;
  }
  .landingPageImage {
    height: auto;
    background: #1e1e1e;
    position: relative;
    width: 100%;
  }
  .landingPageImage .image {
    height: auto;
    width: 100%;
    position: relative;
    background-size: cover;
  }
  .landingPageImage .logo {
    display: none;
  }
  .landingPage .landingPageTinter{
    background-image: linear-gradient(
    to top,
    #1E1E1E 0%,
    #1E1E1E 20%,
    rgb(0,0,0,0.0) 80%
    );
    position: absolute;
    bottom: 0;
    height: 100%;
    width: 100%;
  }
  @media (max-width: 500px) {
    .landingPageText {
      position: absolute;
      right: 2rem;
      left: 2rem;
      top: 10vh;
      display: block;
      justify-content: center;
      text-align: center;
      z-index: 2;
      color: white;
    }
    .landingPageSubTitle {
      font-size: 2vw;
      margin-bottom: 1rem;
    }
  }
  @media (min-width: 500px) {
    .landingPageText {
      position: absolute;
      right: 2rem;
      left: 2rem;
      top: 15vh;
      display: block;
      justify-content: center;
      text-align: center;
      z-index: 2;
      color: white;
    }
    .landingPageSubTitle {
      font-size: 2vw;
      margin-bottom: 3rem;
    }
  }
  
  .landingPageDescription {
    height: 30vh;
    margin-bottom: 5rem;
    width: 100%;
    display: none;
    position: relative;
    background-color: #1E1E1E;
  }
  .landingPageTitle {
    display: block;
    font-size: 3vw;
    font-weight: bold;
    margin-bottom: 0.5rem;
  }
  
  .button {
    font-size: 1.5vw;
    text-decoration: none;
    background: white;
    border-radius: 1rem;
    color: #1e1e1e;
    box-shadow: 0 0 .3rem #1e1e1e;
    height: auto;
    padding: 0.5rem 3rem;
  }
  .landingPageDescription .landingPageDescriptionImage {
    display: none;
  }
  .landingPageDescription .landingPageDescriptionText .landingPageDescriptionTitle {
    display: none;
  }
  .landingPageDescription .landingPageDescriptionText .landingPageDescriptionSubTitle {
    display: none;
  }
}
@media (min-width: 900px) {
  @media (max-width: 1400px) {
    .landingPage {
      position: relative;
      height: auto;
      width: 100%;
    }
    .landingPageImage {
      height: auto;
      width: 100%;
    }
    .landingPageImage .image {
      height: auto;
      width: 100%;
      background: no-repeat center center fixed;
      -webkit-background-size: cover;
      -moz-background-size: cover;    
      -o-background-size: cover;      
      background-size: cover;
    }
    @media (max-width: 1100px) {
      .landingPageImage .logo {
        position: absolute;
        right: 0;
        left: 0;
        top: 20vh;
        margin: 0 auto;
        height: auto;
        width: 80%;
      }
    }
    @media (min-width: 1100px) {
      .landingPageImage .logo {
        position: absolute;
        right: 0;
        left: 0;
        top: 30vh;
        margin: 0 auto;
        height: auto;
        width: 80%;
      }
    }
    .landingPage .landingPageTinter{
      background-image: linear-gradient(
      to top,
      #1E1E1E 0%,
      #1E1E1E 10%,
      rgb(0,0,0,0.0) 20%
      );
      position: absolute;
      bottom: 95vh;
      height: 100%;
      width: 100%;
    }
  }
  @media (min-width: 1400px) {
    .landingPage {
      position: relative;
      height: auto;
      width: 100%;
    }
    .landingPageImage {
      height: 65rem;
      width: 85rem;
    }
    .landingPageImage .image {
      position: absolute;
      top:0;
      bottom: 0;
      right: 0;
      left: 0;
      height: auto;
      width: 100%;
      background: no-repeat center center fixed;
      -webkit-background-size: cover;
      -moz-background-size: cover;    
      -o-background-size: cover;      
      background-size: cover;
    }
    .landingPageImage .logo {
      position: absolute;
      right: 0;
      left: 0;
      top: 35vh;
      margin: 0 auto;
      height: auto;
      width: 80%;
    }
    .landingPage .landingPageTinter{
      background-image: linear-gradient(
      to top,
      #1E1E1E 0%,
      #1E1E1E 10%,
      rgb(0,0,0,0.0) 20%
      );
      position: absolute;
      bottom: 90vh;
      height: 100%;
      width: 100%;
    }
  }
  .landingPageText {
    display: none;
  }
  .landingPageDescription {
    height: 100vh;
    width: 100%;
    display: block;
    position: relative;
    background-color: #1E1E1E;
  }
  .landingPageDescription .landingPageDescriptionText {
    position: absolute;
    display: block;
    width: 40%;
    color: white;
    z-index: 10;
    right: 10rem;
    top: 10rem;
    bottom: 0;
  }
  .landingPageText {
    display: none;
  }
  .landingPageDescription .landingPageDescriptionText .landingPageDescriptionTitle {
    font-size: 2vw;
    font-weight: bold;
    margin-bottom: 1rem;
  }
  .landingPageDescription .landingPageDescriptionText .landingPageDescriptionSubTitle {
    font-size: 1.5vw;
    margin-bottom: 4rem;
  }
  .landingPageDescription .landingPageDescriptionImage {
    position: absolute;
    left: 20%;
    right: auto;
    height: auto;
    padding-top: 4rem;
    width: 40%;
  }
  .landingPageDescription .landingPageDescriptionText .button {
    font-size: 1.5vw;
    text-decoration: none;
    background: white;
    border-radius: 0.5rem;
    color: black;
    cursor: pointer;
    box-shadow: 0 0 1rem black;
    padding: 0.5rem 2rem;
  }
}

.landingPageDescription .landingPageDescriptionTinter {
  position: absolute;
  background-image: linear-gradient(
  to left,
  #1E1E1E 0%,
  #1E1E1E 45%,
  rgb(0,0,0,0.0) 100%
  );
  height: 100%;
  width: 100%;
}

</style>
